const apiUrl = process.env.REACT_APP_API_URL;
export const GetDistribucionsById = async ( page : string, id_proveidor : number ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/proveidors/${id_proveidor}/distribucio`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
